import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{staticClass:"ma-6 top-0 right-0",attrs:{"plain":"","ripple":false,"absolute":"","value":_vm.value},on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c(VIcon,{attrs:{"color":_vm.value ? 'primary' : 'secondary'}},[_vm._v("list")]),_vm._v(" "),_c('small',{staticClass:"ml-2"},[_vm._v("\n        "+_vm._s(_vm.value ? _vm.option1 : _vm.option2)+"\n    ")])],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }